
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from 'react';
// import { getSwarmSubscriptionRequestCashdesk } from '../../../helpers/terminalRequests/cashdesk';
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { counterOfferRounding } from "../../../helpers/sport/betslip";
import { SwarmDataMixin } from "../../../../dev/mixins/swarmDataMixin";
import { GetSuperbetTicketById, SetSuperbetId, RejectSuperbet, SuperbetInProcess } from "../../../actions/terminal";
import { ClosePopup } from "../../../actions/ui";
import PropTypes from 'prop-types';
import Zergling from '../../../helpers/zergling';
import { t } from "../../../helpers/translator";
import Config from '../../../config/main';
import SpinnerCountdown from '../../../components/spinner-countdown';
let terminalId, token, currency, prevAmount, prevPrice;

class Superbet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            acceptedStatus: null,
            superbetStatus: null,
            autoCloseTimer: Config.counterOfferTimer
        };
        this.acceptCounterOffer = this.acceptCounterOffer.bind(this);
        this.rejectCounterOffer = this.rejectCounterOffer.bind(this);
        this.countdownChange = this.countdownChange.bind(this);
        this.handlePrintTicket = this.handlePrintTicket.bind(this);
        this.handleSuperbetId = this.handleSuperbetId.bind(this);
        this.handleRejectSuperbet = this.handleRejectSuperbet.bind(this);
    }

    componentDidMount() {
        terminalId = sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).tid;
        token = sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).token;
        currency = sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).currency;
        prevAmount = this.props.superbetAmount;
        prevPrice = this.props.superbetPrice;
        if (this.props.superBetId) {
            this.handleSuperbetId(this.props.superBetId)();
        }
        this.props.dispatch(SuperbetInProcess(true));
    }

    componentDidUpdate(prevProps, prevState) {
        let isDifferentState = this.state.superbetStatus === 1 && prevState.superbetStatus === null;
        let newSuperbetId = this.props.superBetId,
            updatedProps = this.props.swarmData.cashdesk[terminalId]?.super_bet?.[newSuperbetId]

        if (updatedProps && newSuperbetId === this.props.superBetId && updatedProps.is_counteroffer && !this.state.autoCloseTimerId) {
            const autoCloseTimerId = setInterval(() => {
                this.setState({
                    autoCloseTimer: this.state.autoCloseTimer - 1
                }, () => {
                    if (this.state.autoCloseTimer === 1) {
                        this.rejectCounterOffer(updatedProps.super_bet_id)
                        clearInterval(this.state.autoCloseTimerId)
                    }
                })
            }, [1000])

            this.setState({
                autoCloseTimerId
            })
        }

        if (updatedProps !== undefined && prevProps.superBetId === updatedProps.super_bet_id && updatedProps.super_bet_status === 1) {
            if (prevProps !== this.props) {
                this.setState({ superbetStatus: 1 });
            }
            isDifferentState && this.handlePrintTicket(newSuperbetId)();
            setTimeout(() => {
                this.props.dispatch(ClosePopup());
            }, 5000);
        }
        if (updatedProps !== undefined && updatedProps.super_bet_status === -1) {
            if (prevProps !== this.props) {
                this.setState({ superbetStatus: 1 });
            }
            isDifferentState && this.handleRejectSuperbet(newSuperbetId)();
            setTimeout(() => {
                this.props.dispatch(ClosePopup());
            }, 5000);
        }
    }

    componentWillUnmount() {
        this.props.dispatch(SuperbetInProcess(false));
        clearInterval(this.state.autoCloseTimerId)
    }

    acceptCounterOffer(acceptedStatus, superBetId) {
        Zergling.get({ "Token": token, "Accept": true, "BetId": superBetId }, 'terminal_super_bet_answer')
            .then(data => console.debug(data, "SUPER_BET_DATA"));
        this.setState({
            acceptedStatus: acceptedStatus
        });
    }
    rejectCounterOffer(superBetId) {
        Zergling.get({ "Token": token, "Accept": false, "BetId": superBetId }, 'terminal_super_bet_answer')
            .then(data => console.debug(data, "SUPER_BET_DATA"));
    }

    handlePrintTicket(id) {
        return () => this.props.dispatch(GetSuperbetTicketById(id.toString()));
    }

    handleSuperbetId(id) {
        return () => this.props.dispatch(SetSuperbetId(id.toString()));
    }

    handleRejectSuperbet(id) {
        return () => this.props.dispatch(RejectSuperbet(id.toString()));
    }
    
    countdownChange(seconds) {
        seconds <= 0 && this.props.dispatch(ClosePopup());
    }

    render() {
        let newSuperbetId = this.props.superBetId;
        let superbetResult = this.props.swarmData && this.props.swarmData.cashdesk[terminalId] && this.props.swarmData.cashdesk[terminalId].super_bet && this.props.swarmData.cashdesk[terminalId].super_bet[newSuperbetId];

        if ((!superbetResult || Object.entries(this.props.swarmData.cashdesk).length === 0) && this.props.superBetIsAlreadyAccepted === undefined) {
            return <div className="superbet-window-s">
                {Config.betting.enableSuperBetAutomatically && <SpinnerCountdown duration={Config.superBetCountdownTime} onChange={this.countdownChange} />}
                <p>{t("Offer is under review please wait")}</p>
            </div>;
        }
        if (!superbetResult && this.props.superBetIsAlreadyAccepted !== undefined) {
            if (this.props.superBetIsAlreadyAccepted) {
                return <div className="superbet-window-s">
                    <p>{t("Your bet is accepted.")}</p>
                    <i className="icon-success-light" />
                    <button className="button-submit-betslip-id" onClick={() => this.props.dispatch(ClosePopup())}>{t('Got it')}</button>
                </div>;
            } else {
                return <div className="superbet-window-s superbet-window-s-reject">
                    <p>{t("Your offer has not been approved")}</p>
                    {!!superbetResult?.decline_reason?.trim() && <p>{superbetResult.decline_reason.trim()}</p>}
                    <i className="icon-reject-light" />
                    <button className="button-submit-betslip-id" onClick={() => this.props.dispatch(ClosePopup())}>{t('Got it')}</button>
                </div>;
            }
        }
        if (superbetResult && newSuperbetId === this.props.superBetId && (!superbetResult.is_counteroffer || superbetResult.is_counteroffer === undefined)) {

            if (superbetResult.super_bet_status === 1 || this.state.acceptedStatus === 0) {
                return <div className="superbet-window-s">
                    <p>{t("Your bet is accepted.")}</p>
                    <i className="icon-success-light" />
                    <button className="button-submit-betslip-id" onClick={() => this.props.dispatch(ClosePopup())}>{t('Got it')}</button>
                </div>;
            } else if (superbetResult.super_bet_status === -1) {
                return <div className="superbet-window-s superbet-window-s-reject">
                    <p>{t("Your offer has not been approved")}</p>
                    {!!superbetResult?.decline_reason?.trim() && <p>{superbetResult.decline_reason.trim()}</p>}
                    <i className="icon-reject-light" />
                    <button className="button-submit-betslip-id" onClick={() => this.props.dispatch(ClosePopup())}>{t('Got it')}</button>
                </div>;
            }
        }
        if (superbetResult && newSuperbetId === this.props.superBetId && superbetResult.is_counteroffer) {
            return <div className="superbet-window-s">
                <div className='popup-timer'>{ t('Popup will be closed after') } { this.state.autoCloseTimer } { t('seconds') }</div>
                <h2>{t("Your offer has not been accepted, would you like to accept our offers?")}</h2>
                <div className="counter-offer-s">
                    <div className="counter-offer-s-row">
                        <div className="counter-offer-s-row-inner">
                            <p>{t('Odds')}</p>

                            <div className="counter-offer-s-row-content">
                                <div className="counter-offer-s-row-content-info">
                                    <p className="counter-offer-s-row-content-info-text">{t("Old")}</p>
                                    <p className="counter-offer-s-row-content-info-count">x{counterOfferRounding(prevPrice)}</p>
                                </div>

                                <div className="counter-offer-s-row-content-info new">
                                    <p className="counter-offer-s-row-content-info-text">{t("New")}</p>
                                    <p className="counter-offer-s-row-content-info-count">x{counterOfferRounding(superbetResult.super_bet_price)}</p>
                                </div>
                            </div>
                        </div>
                        <button className="button-submit-betslip-id outline" onClick={() => this.rejectCounterOffer(superbetResult.super_bet_id)}>{t("cancel")}</button>
                    </div>
                    <div className="counter-offer-s-row">
                        <div className="counter-offer-s-row-inner">
                            <p>{t('Stake amount')}</p>

                            <div className="counter-offer-s-row-content">
                                <div className="counter-offer-s-row-content-info">
                                    <p className="counter-offer-s-row-content-info-text">{t("Old")}</p>
                                    <p className="counter-offer-s-row-content-info-count">{prevAmount} {currency}</p>
                                </div>

                                <div className="counter-offer-s-row-content-info new">
                                    <p className="counter-offer-s-row-content-info-text">{t("New")}</p>
                                    <p className="counter-offer-s-row-content-info-count">{superbetResult.super_bet_amount} {currency}</p>
                                </div>
                            </div>
                        </div>
                        <button className="button-submit-betslip-id" onClick={() => this.acceptCounterOffer(superbetResult.super_bet_status, superbetResult.super_bet_id)}>{t("accept")}</button>
                    </div>
                </div>
            </div>;
        }
    }
}

Superbet.propTypes = {
    params: PropTypes.objectOf(PropTypes.any).isRequired,
    user: PropTypes.objectOf(PropTypes.any).isRequired,
    swarmData: PropTypes.object,
    cashdesk: PropTypes.object,
    superBetId: PropTypes.number,
    superbetAmount: PropTypes.number,
    superbetPrice: PropTypes.number,
    superBetIsAlreadyAccepted: PropTypes.bool
};

const mapStateToProps = () => {
    return createSelector(
        [
            state => state.cashdesk,
            state => state.user,
            state => (state.swarmData.data && state.swarmData.data.cashdesk)
        ],
        (cashdesk, user, swarmData) => {
            return {
                cashdesk,
                user,
                swarmData
            };
        }
    );
};
export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: Superbet,
        ComponentWillMount: function () {
            // this.swarmSubscriptionRequest = getSwarmSubscriptionRequestCashdesk(this.props.authData);//todo move this from lottery component
            this.swarmDataKey = 'cashdesk';
            this.keepDataAfterUnsubscribe = true;
        }
    }
));
